import React from 'react';
import { ComponentLayout } from 'src/components/common/modules/component-layout/code-split/component-layout-component';
import { ComponentLayoutType } from 'src/components/common/modules/component-layout/component-layout';
import { GlobalHeroComponent } from './code-split/global-hero-component';

const GlobalHero: React.FC<ComponentLayoutType<any>> = (props) => {
  return (
    <ComponentLayout {...props}>
      <GlobalHeroComponent />
    </ComponentLayout>
  );
};

// export default GlobalHero;

export default React.memo(GlobalHero, (prevProps, nextProps) => {
  return prevProps !== nextProps;
});
